<template>
    <!-- <v-row justify=""> -->
    <v-dialog v-model="dialog" max-width="900px">
        <v-form ref="formVinculaModal">
            <v-card color="grey lighten-4">
                <v-toolbar color="orange" dark>
                    <v-toolbar-title>Criação de vinculo</v-toolbar-title>

                    <v-spacer></v-spacer>
                    <v-btn icon @click="fechar">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text>
                    <v-container fluid>
                        <v-card elevation="2">
                            <v-card-title>Entrega Cliente</v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12">
                                        <InputAutoCompleteLocalV3
                                            v-model="motorista_entrega"
                                            :itemsOpcoes="motoristas"
                                            :smallChips="true"
                                            :regra="regrasMotoristaEntrega"
                                            :deletableChips="true"
                                            tituloBusca="Motorista"
                                            itemValor="id_motorista"
                                            itemTexto="parceiro.nome"
                                            ref="motorista_entrega"
                                        />
                                    </v-col>
                                    <v-col cols="12">
                                        <InputAutoCompleteLocalV3
                                            v-model="veiculo_placa_cavalo_entrega"
                                            :itemsOpcoes="veiculos"
                                            :smallChips="true"
                                            :deletableChips="true"
                                            :regra="regrasVeiculoPlacaCavaloEntrega"
                                            tituloBusca="Cavalo"
                                            itemValor="id_veiculo"
                                            itemTexto="nomeFormatado"
                                            ref="veiculo_placa_cavalo_entrega"
                                        />
                                    </v-col>

                                    <v-col cols="12">
                                        <InputAutoCompleteLocalV3
                                            v-model="veiculo_placa_carreta_entrega"
                                            :itemsOpcoes="veiculos"
                                            :smallChips="true"
                                            :deletableChips="true"
                                            tituloBusca="Carreta"
                                            itemValor="id_veiculo"
                                            itemTexto="nomeFormatado"
                                            reg="veiculo_placa_carreta_entrega"
                                        />
                                    </v-col>

                                    <v-col cols="12">
                                        <InputAutoCompleteLocalV3
                                            v-model="veiculo_placa_carreta_2_entrega"
                                            :itemsOpcoes="veiculos"
                                            :smallChips="true"
                                            :deletableChips="true"
                                            tituloBusca="Carreta 2"
                                            itemValor="id_veiculo"
                                            itemTexto="nomeFormatado"
                                            reg="veiculo_placa_carreta_2_entrega"
                                        />
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <v-divider cols="12" class="pa-2 mx-4"></v-divider>

                        <v-card elevation="2">
                            <v-card-title>Motorista Coleta</v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12">
                                        <InputAutoCompleteLocalV3
                                            v-model="motorista_coleta"
                                            :itemsOpcoes="motoristas"
                                            :smallChips="true"
                                            :deletableChips="true"
                                            :regra="regrasMotoristaColeta"
                                            tituloBusca="Motorista"
                                            itemValor="id_motorista"
                                            itemTexto="parceiro.nome"
                                            ref="motorista_coleta"
                                        />
                                    </v-col>
                                    <v-col cols="12">
                                        <InputAutoCompleteLocalV3
                                            v-model="veiculo_placa_cavalo_coleta"
                                            :itemsOpcoes="veiculos"
                                            :smallChips="true"
                                            :deletableChips="true"
                                            :regra="regrasVeiculoPlacaCavaloColeta"
                                            tituloBusca="Cavalo"
                                            itemValor="id_veiculo"
                                            itemTexto="nomeFormatado"
                                            ref="veiculo_placa_cavalo_coleta"
                                        />
                                    </v-col>

                                    <v-col cols="12">
                                        <InputAutoCompleteLocalV3
                                            v-model="veiculo_placa_carreta_coleta"
                                            :itemsOpcoes="veiculos"
                                            :smallChips="true"
                                            :deletableChips="true"
                                            tituloBusca="Carreta"
                                            itemValor="id_veiculo"
                                            itemTexto="nomeFormatado"
                                            ref="veiculo_placa_cavalo_coleta"
                                        />
                                    </v-col>

                                    <v-col cols="12">
                                        <InputAutoCompleteLocalV3
                                            v-model="veiculo_placa_carreta_2_coleta"
                                            :itemsOpcoes="veiculos"
                                            :smallChips="true"
                                            :deletableChips="true"
                                            tituloBusca="Carreta 2"
                                            itemValor="id_veiculo"
                                            itemTexto="nomeFormatado"
                                            ref="veiculo_placa_carreta_2_coleta"
                                        />
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="fechar" color="red darken-1">
                        <v-icon dense left> mdi-close-circle-outline </v-icon>
                        Fechar
                    </v-btn>

                    <v-btn @click="salvar" color="blue darken-1">
                        <v-icon dense left> mdi-content-save-settings-outline </v-icon>
                        Salvar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
import InputTextV3 from '@/components/Form/InputTextV3.vue';
import InputSelectV3 from '@/components/Form/InputSelectV3.vue';
import InputAutoCompleteLocalV3 from '@/components/Form/InputAutoCompleteLocalV3.vue';
import AlocacaoCargaTipoColetaEnum from '@/Enum/AlocacaoCargaTipoColetaEnum';

export default {
    name: 'vinculaAlocacaoCargaModal',
    components: {
        InputTextV3,
        InputSelectV3,
        InputAutoCompleteLocalV3,
    },
    props: {
        motoristas: {
            type: Array,
        },
        veiculos: {
            type: Array,
        },
    },
    computed: {
        campoFormatacao() {
            const mascaraTelefone = '(##) ####-####';
            const mascaraCelular = '(##) # ####-####';
            const tamanhoCampo = this.telefone_principal
                ? Number(this.telefone_principal.replace(/\D/g, '')).toString().length
                : 0;

            if (tamanhoCampo == 11) {
                return mascaraCelular;
            }

            return mascaraTelefone;
        },
        regrasMotoristaEntrega() {
            if (!(!!this.motorista_entrega || !!this.motorista_coleta)) {
                return ['Campo é obrigatório'];
            }

            return [];
        },
        regrasVeiculoPlacaCavaloEntrega() {
            if (
                !(
                    (!!this.veiculo_placa_cavalo_entrega && !!this.motorista_entrega) ||
                    !!this.motorista_coleta ||
                    (!!this.veiculo_placa_cavalo_entrega && this.motorista_coleta)
                )
            ) {
                return ['Campo é obrigatório com Motorista de Entrega Cliente'];
            }

            return [];
        },
        regrasMotoristaColeta() {
            if (!(!!this.motorista_coleta || !!this.motorista_entrega || !!this.veiculo_placa_cavalo_entrega)) {
                return ['Campo é obrigatório ou selecione um Motorista de Entrega Cliente'];
            }

            return [];
        },
        regrasVeiculoPlacaCavaloColeta() {
            if (
                !(
                    (!!this.veiculo_placa_cavalo_coleta && !!this.motorista_coleta) ||
                    !!this.motorista_entrega ||
                    (!!this.veiculo_placa_cavalo_coleta && this.motorista_entrega)
                )
            ) {
                return ['Campo é obrigatório com Motorista de Coleta ou selecione um Motorista de Entrega Cliente'];
            }

            return [];
        },
    },
    data() {
        return {
            dialog: false,
            motorista_entrega: null,
            veiculo_placa_cavalo_entrega: null,
            veiculo_placa_carreta_entrega: null,
            veiculo_placa_carreta_2_entrega: null,
            motorista_coleta: null,
            veiculo_placa_cavalo_coleta: null,
            veiculo_placa_carreta_coleta: null,
            veiculo_placa_carreta_2_coleta: null,
            telefone_principal: null,
            regraMotorista: [(v) => !!v || 'Campo é obrigatório'],
            regraPlaca1: [(v) => !!v || 'Campo é obrigatório'],
            regraTelefonePrincipal: [(v) => v == null || v.length >= 14 || 'Não pode ter mais que 11 caracteres'],
            regrasTipoColeta: [(v) => !!v || 'Campo é obrigatório'],
        };
    },
    methods: {
        salvar() {
            const validaCampos = this.validaCampos();

            if (!validaCampos) {
                return;
            }

            let dadosEntrega = {};
            let dadosColeta = {};

            if (!!this.motorista_entrega) {
                dadosEntrega = {
                    motorista: this.motoristas.find((motorista) => motorista.id_motorista === this.motorista_entrega),
                    id_veiculo_placa_cavalo: this.veiculo_placa_cavalo_entrega,
                    id_veiculo_placa_carreta: this.veiculo_placa_carreta_entrega,
                    id_veiculo_placa_carreta_2: this.veiculo_placa_carreta_2_entrega,
                    tipo_coleta_entrega: AlocacaoCargaTipoColetaEnum.ENTREGA_CLIENTE,
                    placa_cavalo: this.veiculos.find((veiculo) => veiculo.id_veiculo === this.veiculo_placa_cavalo_entrega),
                    placa_carreta: this.veiculos.find((veiculo) => veiculo.id_veiculo === this.veiculo_placa_carreta_entrega),
                    placa_carreta_2: this.veiculos.find(
                        (veiculo) => veiculo.id_veiculo === this.veiculo_placa_carreta_2_entrega
                    ),
                };
            }

            if (!!this.motorista_coleta) {
                dadosColeta = {
                    motorista: this.motoristas.find((motorista) => motorista.id_motorista === this.motorista_coleta),
                    id_veiculo_placa_cavalo: this.veiculo_placa_cavalo_coleta,
                    id_veiculo_placa_carreta: this.veiculo_placa_carreta_coleta,
                    id_veiculo_placa_carreta_2: this.veiculo_placa_carreta_2_coleta,
                    tipo_coleta_coleta: AlocacaoCargaTipoColetaEnum.CROSSDOCKING,
                    placa_cavalo: this.veiculos.find((veiculo) => veiculo.id_veiculo === this.veiculo_placa_cavalo_coleta),
                    placa_carreta: this.veiculos.find((veiculo) => veiculo.id_veiculo === this.veiculo_placa_carreta_coleta),
                    placa_carreta_2: this.veiculos.find(
                        (veiculo) => veiculo.id_veiculo === this.veiculo_placa_carreta_2_coleta
                    ),
                };
            }

            this.$emit('vincular', {
                motorista_entrega: dadosEntrega,
                motorista_coleta: dadosColeta,
                telefone_principal: this.telefone_principal,
            });

            this.fechar();
        },
        validaCampos() {
            if (!this.$refs['formVinculaModal'].validate()) {
                return false;
            }

            return true;
        },
        fechar() {
            this.dialog = false;
            this.motorista_entrega = null;
            this.veiculo_placa_cavalo_entrega = null;
            this.veiculo_placa_carreta_entrega = null;
            this.veiculo_placa_carreta_2_entrega = null;
            this.motorista_coleta = null;
            this.veiculo_placa_cavalo_coleta = null;
            this.veiculo_placa_carreta_coleta = null;
            this.veiculo_placa_carreta_2_coleta = null;
            this.telefone_principal = null;

            this.$emit('fechouModal');
        },
    },
};
</script>
